// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const collectionSelectModalActions = require('client-v2/common/containers/collection-select-modal/actions')
const collectionSelectModalSelectors = require('client-v2/common/containers/collection-select-modal/selectors')
// Sibling imports
const AddToCollectionModal = require('./modal-dumb')

function mapStateToProps(state) {
  return {
    // Flags
    isCreateButtonDisabled: collectionSelectModalSelectors.isCreatePending(state),
    isCreateButtonVisible: collectionSelectModalSelectors.canCreateFromFilter(state),
    isCollectionsLoaded: collectionSelectModalSelectors.isCollectionsLoaded(state),
    isCollectionsFailed: collectionSelectModalSelectors.isCollectionsFailed(state),
    isFilteredCollectionsEmpty: collectionSelectModalSelectors.isFilteredCollectionsEmpty(state),
    isUnfilteredCollectionsEmpty: collectionSelectModalSelectors.isUnfilteredCollectionsEmpty(state),
    isUnmixDisabled: collectionSelectModalSelectors.isUnmixPending(state),
    isUnmixPromptVisible: collectionSelectModalSelectors.isUnmixPromptVisible(state),
    isUnmixVisible: collectionSelectModalSelectors.isUnmixVisible(state),
    isVisible: true,
    // Values
    collections: collectionSelectModalSelectors.filteredCollections(state),
    filterText: collectionSelectModalSelectors.filterText(state)
  }
}

const mapDispatchToProps = {
  onDismiss: collectionSelectModalActions.hide,
  onCreate: collectionSelectModalActions.createCollectionFromFilter,
  onCollectionClick: collectionSelectModalActions.toggleCollection,
  onFilterTextChange: collectionSelectModalActions.setFilterText,
  onRetry: collectionSelectModalActions.fetch,
  onUnmix: collectionSelectModalActions.showUnmixPrompt,
  onUnmixPromptCancel: collectionSelectModalActions.cancelUnmix,
  onUnmixPromptConfirm: collectionSelectModalActions.confirmUnmix
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    AddToCollectionModal
  )
)
